import services from 'services/module';
import {Utils} from 'underscore-extensions';

export const IntersectionObserver = (window as any).IntersectionObserver;

export abstract class Observer {

    constructor(private emmiter: Function) {
        this.onInit();
    }

    protected onInit() {}

    public abstract subscribe(element: HTMLElement, centredOn?: number): void;

    public abstract unsubscribe(element: HTMLElement): void;

    public abstract checker(): void;

    protected whenOnScreen(element: HTMLElement) {
        this.emmiter('onScreen:' + element.id);
        element.classList.add('on-screen');
        element.classList.remove('not-on-screen');
    }

    protected whenNotOnScreen(element: HTMLElement) {
        this.emmiter('notOnScreen:' + element.id);
        element.classList.add('not-on-screen');
        element.classList.remove('on-screen');
    }
}

type Observable = {
    element: HTMLElement,
    wasOnScreen: boolean,
    wasOutOfScreen: boolean,
    centredOn: number
}

export class ScrollObserver extends Observer {
    observables: Array<Observable> = [];
    staticWindowHeight: string;

    onInit() {
        window.addEventListener('scroll', _.throttle(() => this.checker(), 100), false);
    }

    checker() {
        return Utils.rAF(() => {
            const windowHeight = this.staticWindowHeight ? +this.staticWindowHeight : window.innerHeight;

            this.observables.forEach((o: Observable) => {
                const dimension  = o.element.getBoundingClientRect(),
                      top        = dimension.top,
                      bottom     = dimension.bottom,
                      height     = dimension.height,
                      topVisible = top + height >= 0,
                      botVisible = bottom - height <= windowHeight;

                let onScreen     = topVisible && botVisible;

                if (o.centredOn) {
                    const windowPlace = windowHeight * (o.centredOn / 100);
                    onScreen          = top <= windowPlace && bottom >= windowPlace;
                }

                if (onScreen && !o.wasOnScreen && o.wasOutOfScreen) {
                    o.wasOnScreen    = true;
                    o.wasOutOfScreen = false;
                    this.whenOnScreen(o.element);
                } else if (!onScreen && o.wasOnScreen && !o.wasOutOfScreen) {
                    o.wasOnScreen    = false;
                    o.wasOutOfScreen = true;
                    this.whenNotOnScreen(o.element);
                }
            });
        });
    }

    subscribe(element: HTMLElement, centredOn?: number) {
        this.observables.push({
            element,
            centredOn,
            wasOnScreen: false,
            wasOutOfScreen: true
        });
    }

    unsubscribe(element: HTMLElement) {
        this.observables = this.observables.filter(o => o.element !== element);
    }
}
export class IntersctObserver extends Observer {
    observer: any = new IntersectionObserver(this.checker.bind(this));

    checker(changes?: Array<any>) {
        changes && Utils.rAF(() => changes.forEach(change => {
            const onScreen = change.intersectionRatio !== 0;

            if (onScreen) {
                this.whenOnScreen(change.target);
            } else if (!onScreen) {
                this.whenNotOnScreen(change.target);
            }
        }));
    }

    subscribe(element: HTMLElement) {
        this.observer.observe(element);
    }

    unsubscribe(element: HTMLElement) {
        this.observer.unobserve(element);
    }
}

//IE 11 fix for .middle
HTMLElement.prototype.getBoundingClientRect = (function () {
    const oldGetBoundingClientRect = HTMLElement.prototype.getBoundingClientRect;
    return function (this: any) {
        try {
            return oldGetBoundingClientRect.apply(this, arguments);
        } catch (e) {
            return {
                left: '',
                right: '',
                top: '',
                bottom: ''
            };
        }
    };
})();

function ViewPortSvc($rootScope: ng.IRootScopeService): Observer {
    const emmiter = $rootScope.$emit.bind($rootScope);
    // const observer: Observer = IntersectionObserver ? new IntersctObserver(emmiter) : new ScrollObserver(emmiter);
    return new ScrollObserver(emmiter);
}
services.service('ViewPortSvc', ViewPortSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/ViewPortSvc.ts